module.exports = __webpack_public_path__ + "static/media/YF32_3.250aa04e.jpg";